import { gql } from "../../../../../gql/__generated__/gql";

export const GENERATE_UPLOAD_URL = gql(`
  mutation generateUploadUrl($input: GenerateUploadUrlInput!) {
    generateUploadUrl(input: $input) {
      uploadUrl
      fileUrl
      key
    }
  }
`);
